import en, { noEmbeddedInput as enNoInput, email as enEmail } from './en';
import uk, { noEmbeddedInput as ukNoInput, email as ukEmail, search as ukSearch } from './uk';

export const noEmbeddedInputLayouts = {
  en: enNoInput,
  uk: ukNoInput,
};

export const emailLayouts = {
  en: enEmail,
  uk: ukEmail,
};

export const searchLayouts = {
  uk: ukSearch,
};

export default { en, uk };
